import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { SnackbarComponent } from 'src/app/features/snackbar/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private snackbar: MatSnackBar) {}

  configSuccess: MatSnackBarConfig = {
    panelClass: 'snackbar-success',
    duration: 5000,
    horizontalPosition: 'center',
    verticalPosition: 'top',
  };

  configError: MatSnackBarConfig = {
    panelClass: 'snackbar-error',
    duration: 10000,
    horizontalPosition: 'center',
    verticalPosition: 'top',
  };

  openSnackBar(message: string) {
    this.snackbar.openFromComponent(SnackbarComponent, {
      data: message,
      ...this.configSuccess,
    });
  }

  openErrorSnackBar(message: string) {
    this.snackbar.openFromComponent(SnackbarComponent, {
      data: message,
      ...this.configError,
    });
  }

  openUpdateSnackBar() {
    const configUpdate: MatSnackBarConfig = {
      panelClass: 'snackbar-update',
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    };

    const snackbarRef = this.snackbar.openFromComponent(SnackbarComponent, {
      data: 'New version available! Please reload to update.',
      ...configUpdate,
    });

    return snackbarRef.afterDismissed();
  }
}
